import TenantEntity from "../entities/Tenant.Entity";
import { apiGet } from '../support/helpers/ApiConnection.Helper';


export function getTenants(abortSignal: AbortSignal): Promise<Array<TenantEntity>> {   
    return apiGet<Array<TenantEntity>>('/tenants',abortSignal);
}
